<template>
  <div class="withdraw_page" style="width:1400px;margin: auto;">
    <div style="width:100%;height:68px;background: #E4E6EF;display: flex;align-content: center;">
      <router-link to="/spreader/home" style="margin: auto 0 auto 20px;" exact>
        <img width="32px" height="32px" src="../../assets/spreader/return.png" />
      </router-link>
      <p style="font-size: 20px; font-family: Microsoft YaHei; 
      font-weight: bold; color: rgb(41, 41, 41); margin: 0px 0px 0px 20px; padding: 0px; line-height: 68px;">返回首页</p>
    </div>
    <div style="background: #FFFFFF;height: 1000px;">
      <div>
        <div style="display: flex;align-content: center;padding: 30px 0 0 72px;">
          <div style="width:4px;height:18px;background: #347BFF;border-radius: 2px;margin: auto 0;"></div>
          <span
            style="font-size: 20px;font-family: Microsoft YaHei;font-weight: 400;color: #292929;margin-left: 12px;">个人银行卡提现</span>
        </div>
        <div style="margin: 10px 0 0 90px;">
          <div style="font-size: 14px;font-family: Microsoft YaHei;font-weight: 400;color: #999999;">
            每次提现需要审批，提交申请请耐心等候且每次提现不低于￥{{spreaderExtract}}
          </div>
          <div style="width:600px;height:284px;background: #F3F4F9;border-radius: 12px;margin-top: 30px;">
            <div style="padding: 40px 0 0 40px;">
              <p style="margin:0;padding:0;font-size: 16px;
                  font-family: Microsoft YaHei;
                  font-weight: bold;
                  color: #292929;">提现金额</p>
              <div class="withdraw_page1" style="width:520px;margin-top: 16px;">
                <el-input type="text" v-model="inputGetBalance" :placeholder="'可提现金额' + userInfo.getBalance"
                  @input="inputChange">
                  <i slot="prefix" style="line-height:52px;font-style:normal;font-size: 20px;
                    font-family: Microsoft YaHei;font-weight: bold;color: #333333;">￥</i>

                  <i slot="suffix" style="line-height:52px;font-style:normal;font-size: 16px;
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    color: #347BFF;" @click="allExtract">全部提现</i>
                </el-input>
              </div>
              <p style="margin:0;padding:12px 0 0 0;font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #999999;">实际到账：{{ realityPrice }} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 手续费：{{ serviceCharge }}
              </p>
              <button style="margin-top:50px;background: #347BFF;border-radius: 4px;border:0px;width: 128px;height: 40px;font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #FFFFFF;cursor: pointer;" @click="clickExtractButton">提现</button>
            </div>
          </div>
          <div style="height:20px;line-height:20px;margin-top: 21px;display: flex;align-content: center;">
            <span style="font-size: 14px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: #292929;padding-left: 15px;">温馨提示</span>
          </div>
          <p style="font-size: 14px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #999999;
            line-height: 24px;padding-left: 15px;" v-html="extractRuleStr">
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { subtract } from 'mathjs';
import { accMul } from '../../utils/mathUtils';
import { extract,getSpreaderExtract } from '@/api/spreader/extract';
import { getConfigs, getConfig } from '@/api/spreader/config';

export default {
  name: "withdraw_page",
  props: {
    userInfo: {
      nickname: '',
      headPic: '',
      code: '',
      getBalance: '',
      gotBalance: '',
      inviterNum: '',
      idCardName: '',
      tel: '',
      idCardNum: '',
      bankCardName: '',
      bankCardNum: '',
    }
  },
  components: {
  },
  created() {
  },
  destroyed: function () {
  },
  mounted: function () {
    this.getExtractRuleStr();
    this.getSpreaderExtract();
  },
  methods: {
    //点击确定提现按钮
    clickExtractButton() {
      let inputGetBalanceFloat = parseFloat(this.inputGetBalance);
      if (inputGetBalanceFloat <= 0) {
        this.$message('请输入提现金额');
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: '正在提交!',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      let data = {
        spreaderId: JSON.parse(sessionStorage.getItem("userInfo")).id,
        extractPrice: this.realityPrice,
        serviceCharge: this.serviceCharge
      }
      return new Promise((resolve, reject) => {
        extract(data).then(res => {
          if (res.status == 200) {
            this.$emit('getInfo');
            this.$message('提现申请成功，三个工作日内将审核完毕');
          } else {
            this.$message(res.message);
          }
          loading.close();
        })
      })
    },
    //点击全部提现
    allExtract() {
      this.inputGetBalance = this.userInfo.getBalance;
      this.acount();
    },
    //输入变化
    inputChange(value) {
      this.inputGetBalance =
        ("" + value) // 第一步：转成字符串
          .replace(/[^\d^\.]+/g, "") // 第二步：把不是数字，不是小数点的过滤掉
          .replace(/^0+(\d)/, "$1") // 第三步：第一位0开头，0后面为数字，则过滤掉，取后面的数字
          .replace(/^\./, "0.") // 第四步：如果输入的第一位为小数点，则替换成 0. 实现自动补全
          .match(/^\d*(\.?\d{0,2})/g)[0] || ""; // 第五步：最终匹配得到结果 以数字开头，只有一个小数点，而且小数点后面只能有0到2位小数
      this.acount();
    },
    acount() {
      this.serviceCharge = accMul(this.inputGetBalance, 0.05);

      this.realityPrice = subtract(this.inputGetBalance, this.serviceCharge).toFixed(2);
    },
    //获取提现规则字符串
    getExtractRuleStr() {
      let data = {
        cid: 17
      }
      return new Promise((resolve, reject) => {
        getConfig(data).then(res => {
          if (res.status == 200) {
            this.extractRuleStr = res.data.zh;
          } else {
            this.$message(res.message);
          }
        })
      })
    },
    getSpreaderExtract(){
      return new Promise((resolve, reject) => {
        getSpreaderExtract().then(res => {
          if (res.status == 200) {
            this.spreaderExtract = res.data;
          } else {
            this.$message(res.message);
          }
        })
      })
    }
  },
  data() {
    return {
      realityPrice: '0.00',
      serviceCharge: '0.00',
      inputGetBalance: '',
      extractRuleStr: '',
      spreaderExtract: '',
    };
  },
};
</script>

<style>
.withdraw_page1 .el-input__inner {
  height: 52px;
  line-height: 52px;
}

.withdraw_page1 .el-input__suffix {
  padding-right: 15px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/spreader/withdraw.vue